'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = exports.format = exports.cookie = exports.net = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _net = require('./net');

var _net2 = _interopRequireDefault(_net);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import jwt from './net/token';

var util = (0, _extends3.default)({}, _base2.default, _net2.default);

var cookie = _base2.default.cookie,
    format = _base2.default.format,
    log = _base2.default.log;

// 用于“import util”可用

exports.default = util;
// 用于“window.CNTarsUtil”

exports.net = _net2.default;
exports.cookie = cookie;
exports.format = format;
exports.log = log;